import gql from 'graphql-tag'

export default gql`mutation toggleDashboardWidget($widget: DashboardWidgetInput, $toggle: Boolean, $user_id: Int) {
  toggleDashboardWidget(widget: $widget, toggle: $toggle, user_id: $user_id) @client
}`